import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  getSocialPosts,
  getFollowedSocialPosts,
} from '@/src/actions/social-posts';
import { ISocialPost } from 'types/src/types';

export function useProfilePosts(uniqueLink: string) {
  return useInfiniteQuery({
    queryKey: ['profilePosts', uniqueLink],
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getSocialPosts(null, pageParam, 50, uniqueLink);
    },
    getNextPageParam: (lastPage, pages) => {
      const count = lastPage?.items?.length ?? 0;
      return count === 50 ? pages.length + 1 : undefined;
    },
  });
}

export function useDiscoverPosts(
  enabled: boolean,
  searchText: string,
  gameSlug?: string,
  initialPosts?: ISocialPost[]
) {
  const hasGameFilter = !!gameSlug;

  return useInfiniteQuery({
    queryKey: ['discoverPosts', searchText, gameSlug ?? ''],
    enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam }) => {
      return getSocialPosts(
        null,
        Number(pageParam ?? 1),
        50,
        undefined,
        searchText,
        gameSlug
      );
    },
    getNextPageParam: (lastPage, pages) => {
      const count = lastPage?.posts?.length ?? 0;
      return count === 50 ? pages.length + 1 : undefined;
    },
    initialData:
      !hasGameFilter && initialPosts?.length
        ? ({
            pages: [{ posts: initialPosts }],
            pageParams: [1],
          } as InfiniteData<any>)
        : undefined,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  });
}


export function useFollowingPosts(
  enabled: boolean,
  searchText: string,
  gameSlug?: string
) {
  return useInfiniteQuery({
    queryKey: ['followedPosts', searchText, gameSlug ?? ''],
    enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getFollowedSocialPosts(pageParam, 50, searchText, gameSlug);
    },
    getNextPageParam: (lastPage, pages) => {
      const count = lastPage?.posts?.length ?? 0;
      return count === 50 ? pages.length + 1 : undefined;
    },
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  });
}

